import React from 'react'
import PropTypes from 'prop-types';
import NoticePage from './NoticePage';


function Index(
    {
        expanded
    }) {
    return expanded && <NoticePage />
}

Index.propTypes = {
    expanded: PropTypes.bool,
}

export default Index;